

import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import apiUrl from '../../environment/Api';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import Select from "react-select";
import ActionsDropdown from '../ActionsDropdown';
import styled from "styled-components";
import {
    useTable,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";



const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
    return (
        <div style={{ marginBottom: "10px" }}>
            <input
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Search all columns..."
                style={{
                    padding: "5px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    width: "100%",
                }}
            />
        </div>
    );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
    column: { filterValue, setFilter, preFilteredRows, id },
}) => {
    const [isActive, setIsActive] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const options = useMemo(() => {
        const uniqueValues = Array.from(
            new Set(preFilteredRows.map((row) => row.values[id]))
        ).map((value) => ({ label: value, value }));
        return [{ label: "All", value: "" }, ...uniqueValues];
    }, [id, preFilteredRows]);

    // Handle icon click
    const handleIconClick = () => {
        setIsActive(!isActive);
    };

    const handleMultiSelectChange = (selectedOptions) => {
        const values = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
        setFilter(values.length > 0 ? values : undefined);
    };

    return (
        <div style={{ alignItems: "center" }}>
            <div>
                <i
                    className="fa-solid fa-ellipsis-vertical"
                    onClick={handleIconClick}
                    style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "#AC0000",
                    }}
                ></i>
            </div>
            <div>
                {isActive &&
                    createPortal(
                        <div
                            style={{
                                position: "fixed",
                                zIndex: 9999,
                                left: "50%",
                                top: "50%",
                                width: "30%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    background: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    backgroundColor: "#A70000",
                                }}
                            >
                                <Select
                                    options={options}
                                    isMulti
                                    value={options.filter((option) =>
                                        filterValue?.includes(option.value)
                                    )}
                                    onChange={handleMultiSelectChange}
                                    isClearable
                                    isSearchable
                                    placeholder={`Filter ${id}`}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                                <button
                                    style={{
                                        marginTop: "10px",
                                        marginLeft: "150px",
                                        padding: "5px 10px",
                                        background: "#007bff",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setIsActive(false)} // Close the popup
                                >
                                    Close
                                </button>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
        </div>
    );
};








function Student_internship() {

    const [responseData, setResponseData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isUpdateshowModal, setUpdateShowModal] = useState(false);
    const [isPreviewshowModal, setisPreviewShowModal] = useState(false);
    const [branch, setbranch] = useState([]);
    const [role_id, setroleid] = useState('');
    const [previllages, setprevillages] = useState({})
    const [loading, setLoading] = useState(false)
    const [addData, setAddData] = useState({


        branch_id: '',
        type: '',
        full_name: '',
        gender: '',
        contact: '',
        email_address: '',
        course_department: '',
        year_of_study: '',
        // roll_number: '',
        year_of_passout: '',
        Institution_name: '',
        preferred_training: '',



        from_date: '',
        to_date: '',
        no_of_days: '',
        fees: '',
        domain: '',
        remarks: '',
        other_details: "",
    });


    const [updateData, setUpdateData] = useState({

        branch_id: '',
        type: '',
        full_name: '',
        gender: '',
        contact: '',
        email_address: '',
        course_department: '',
        year_of_study: '',
        // roll_number: '',
        year_of_passout: '',
        Institution_name: '',
        preferred_training: '',

        from_date: '',
        to_date: '',
        no_of_days: '',
        fees: '',
        domain: '',
        remarks: '',
        other_details: "",

    });

    useEffect(() => {
        fetchData();
        fetchDataed();
        gettoken();
        getprevillages();
        window.scrollTo(0, 0);
    }, []);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + "/internship_student", {
                params: { data: localStorage.getItem("branch_id") },
            });
            console.log("Response from server:", response.data);
            setResponseData(response.data.reverse());
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };


    const fetchDataed = async () => {
        try {
            const response = await axios.get(apiUrl + "/Branch");
            console.log("Response from server:", response.data);
            setbranch(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };




    const gettoken = async () => {
        const token = localStorage.getItem('token');

        try {
            const response = await axios.post(apiUrl + "/get_detail", { "token": token });
            console.log("token detail from server:", response.data);


            setroleid(response.data.detail.rolename);

            localStorage.setItem('role_id', response.data.detail.rolename);

            const id = response.data.detail.rolename

            if (id) {

            }

        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }
    const getprevillages = () => {
        const username = JSON.parse(localStorage.getItem("user_previllages"));
        console.log("tyhe username get by local stroage : ", username.modules);
        const total_previlages = username.modules;
        const new_enquiry = total_previlages.find((item) => item.name == "Skill Development")
        console.log("the new_enquiry is : ", new_enquiry.actions);

        setprevillages(new_enquiry.actions)
    }




    // const handleNewButtonClick = () => {
    //     if (previllages.add || previllages.all) {
    //     setShowModal(true);
    // }else{
    //     toast.error("You don't have the permission to add");
    // }
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // First, validate the form data
        if (!validateFields()) {
            console.log("Validation failed");
            return; // Stop the submit if validation fails
        }

        try {
            // Collect the form data
            const formData = {
                branch_id: addData.branch_id,
                type: addData.type,
                full_name: addData.full_name,
                gender: addData.gender,
                contact: addData.contact,
                email_address: addData.email_address,
                course_department: addData.course_department,
                year_of_study: addData.year_of_study,
                year_of_passout: addData.year_of_passout,
                Institution_name: addData.Institution_name,
                preferred_training: addData.preferred_training,
                from_date: addData.from_date,
                to_date: addData.to_date,
                no_of_days: addData.no_of_days,
                fees: addData.fees,
                domain: addData.domain,
                remarks: addData.remarks,
                other_details: addData.other_details,
            };

            // Set loading state before submitting
            setLoading(true);

            // Make the API call
            const response = await axios.post(apiUrl + "/internship_student", formData);
            console.log("Data added successfully:", response);

            // Close modal and reset the form
            setShowModal(false);
            toast.success("Added successfully!");

            // Reset form data after successful submission
            setAddData({
                branch_id: '',
                type: '',
                full_name: '',
                gender: '',
                contact: '',
                email_address: '',
                course_department: '',
                year_of_study: '',
                year_of_passout: '',
                Institution_name: '',
                preferred_training: '',
                from_date: '',
                to_date: '',
                no_of_days: '',
                fees: '',
                domain: '',
                remarks: '',
                other_details: '',
            });

            // Fetch updated data
            fetchData();
            setTimeout(() => setLoading(false), 1000); // Reset loading after 1 second

        } catch (error) {
            console.error("Error updating data:", error.message);
            setLoading(false); // Stop loading on error
        }
    };


    const [updateid, setUpdateId] = useState("");

    const handleUpdate = (_id, data) => {
        // if (previllages.edit || previllages.all) {
        setUpdateId(_id)
        console.log(" the data to updata", data)
        setUpdateShowModal(true);
        setUpdateData({

            branch_id: data.branch_id,
            type: data.type,
            full_name: data.full_name,
            gender: data.gender,
            contact: data.contact,
            email_address: data.email_address,
            course_department: data.course_department,
            year_of_study: data.year_of_study,
            year_of_passout: data.year_of_passout,
            Institution_name: data.Institution_name,
            preferred_training: data.preferred_training,
            from_date: data.from_date,
            to_date: data.to_date,
            no_of_days: data.no_of_days,
            fees: data.fees,
            domain: data.domain,
            remarks: data.remarks,
            other_details: data.other_details,


        })
        // } else {
        //     toast.error("You don't have the permission to update");
        // }
    }



    const handlepreview = (_id, data) => {

        setUpdateId(_id)
        console.log(" the data to updata", data)
        setisPreviewShowModal(true);
        setUpdateData({

            branch_id: data.branch_id,
            type: data.type,
            full_name: data.full_name,
            gender: data.gender,
            contact: data.contact,
            email_address: data.email_address,
            course_department: data.course_department,
            year_of_study: data.year_of_study,
            year_of_passout: data.year_of_passout,
            Institution_name: data.Institution_name,
            preferred_training: data.preferred_training,
            from_date: data.from_date,
            to_date: data.to_date,
            no_of_days: data.no_of_days,
            fees: data.fees,
            domain: data.domain,
            remarks: data.remarks,
            other_details: data.other_details,


        })

    }




    const handleupdatesubmit = async (e) => {
        e.preventDefault();
        try {

            const formData = {


                branch_id: updateData.branch_id,
                type: updateData.type,
                full_name: updateData.full_name,
                gender: updateData.gender,
                contact: updateData.contact,
                email_address: updateData.email_address,
                course_department: updateData.course_department,
                year_of_study: updateData.year_of_study,
                year_of_passout: updateData.year_of_passout,
                Institution_name: updateData.Institution_name,
                preferred_training: updateData.preferred_training,
                from_date: updateData.from_date,
                to_date: updateData.to_date,
                no_of_days: updateData.no_of_days,
                fees: updateData.fees,
                domain: updateData.domain,
                remarks: updateData.remarks,
                other_details: updateData.other_details,

            }
            console.log("the update submit data", formData)
            // setLoading(true);
            const response = await axios.put(apiUrl + `/internship_student/${updateid}`, formData)
            console.log("response for update", response)
            setUpdateShowModal(false)
            toast.success("Update successfully!");
            // setTimeout(() => {
            //     setLoading(false);
            //   }, 1000);
            fetchData();
        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    }



    const handleDelete = async (id) => {
        try {


            const response = await axios.delete(apiUrl + `/internship_student/${getdeleteid}`)
            console.log("delete data ", response)
            toast.error("Delete successfully!");
            setDeleteShowModals(false);

            fetchData();
        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }


    };


    const [deleteShowModals, setDeleteShowModals] = useState(false);
    const handleCloseModal = () => {
        setDeleteShowModals(false);
    }

    const [getdeleteid, setdeleteid] = useState('')

    const [getdeletename, setdeletename] = useState('')
    const handleOpenModal = (_id, full_name) => {
        if (previllages.all || previllages.delete) {
            console.log(" the id", _id)
            console.log(" the name", full_name)
            setdeleteid(_id);
            setdeletename(full_name);
            setDeleteShowModals(true);
        } else {
            toast.error("You don't have the permission to delete");
        }
    }


    // the pagination ---------------------------------------------------------------------
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Search
    const filtered = currentItems.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (typeof value === "number" && value.toString().includes(searchQuery))
        )
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(responseData.length / itemsPerPage);

    const goToNextPage = () => {
        setCurrentPage((prevPage) =>
            prevPage === totalPages ? prevPage : prevPage + 1
        );
    };

    const goToPrevPage = () => {
        setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
    };
    // the pagination  end ---------------------------------------------------------------------

    const formatDatefitching = (isoDate) => {
        if (!isoDate) return ""; // Return an empty string if no date is provided
        const date = new Date(isoDate);
        return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return ""; // Return an empty string if no date is provided
        const date = new Date(isoDate);

        const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
        const year = date.getFullYear();

        return `${day}-${month}-${year}`; // Format as "day-month-year"
    };

    const [errors, setErrors] = useState({});

    const validateFields = () => {
        let tempErrors = {};
        let isValid = true;

        if (!addData.branch_id) {
            tempErrors.branch_id = "branch is required.";
            isValid = false;
        }

        if (!addData.type) {
            tempErrors.type = "Select Brand is required.";
            isValid = false;
        }

        if (!addData.full_name) {
            tempErrors.full_name = "Full Name is required.";
            isValid = false;
        }

        if (!addData.gender) {
            tempErrors.gender = "Gender is required.";
            isValid = false;
        }

        if (!addData.contact) {
            tempErrors.contact = "Mobile Number is required.";
            isValid = false;
        }

        if (!/^\d{10}$/.test(addData.contact)) {
            tempErrors.contact = "Mobile number must be 10 digits.";
            isValid = false;
        }

        if (!addData.email_address) {
            tempErrors.email_address = "Email is required.";
            isValid = false;
        }
        if (
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email_address)
        ) {
            tempErrors.email_address = "Please enter a valid email address.";
            isValid = false;
        }

        if (!addData.course_department) {
            tempErrors.course_department = "please Enter your Department.";
            isValid = false;
        }

        if (!addData.year_of_study) {
            tempErrors.year_of_study = "Select Department is required.";
            isValid = false;
        }

        if (!addData.year_of_passout) {
            tempErrors.year_of_passout = " Passout is required.";
            isValid = false;
        }

        if (!addData.Institution_name) {
            tempErrors.Institution_name = " Institution Name is required.";
            isValid = false;
        }


        if (!addData.preferred_training) {
            tempErrors.preferred_training = " preferred_training  is required.";
            isValid = false;
        }

        if (!addData.from_date) {
            tempErrors.from_date = " From Date  is required.";
            isValid = false;
        }

        if (!addData.to_date) {
            tempErrors.to_date = " To Date  is required.";
            isValid = false;
        }

        if (!addData.no_of_days) {
            tempErrors.no_of_days = " No.Of.Days  is required.";
            isValid = false;
        }

        if (!addData.fees) {
            tempErrors.fees = " Fees  is required.";
            isValid = false;
        }

        if (!addData.domain) {
            tempErrors.domain = " Domain  is required.";
            isValid = false;
        }


        if (!addData.remarks) {
            tempErrors.remarks = " Remarks  is required.";
            isValid = false;
        }



        setErrors(tempErrors);
        return isValid;
    };

    console.log(validateFields)





    const data = useMemo(() => {
        return responseData.map((item) => ({
            _id: item._id,
            branch_id: {
                _id: item.branch_id?._id ?? null,
                branch_name: item.branch_id?.branch_name ?? "",
            },
            type: item.type,
            full_name: item.full_name,
            gender: item.gender,
            contact: item.contact,
            email_address: item.email_address,
            course_department: item.course_department,
            year_of_study: item.year_of_study,
            roll_number: item.roll_number,
            Institution_name: item.Institution_name,
            preferred_training: item.preferred_training,
            year_of_passout: item.year_of_passout,
            from_date: item.from_date,
            to_date: item.to_date,
            no_of_days: item.no_of_days,
            fees: item.fees,
            domain: item.domain,
            other_details: item.other_details,
            remarks: item.remarks,







        }));
    }, [responseData]);

    const columns = useMemo(
        () => [
            {
                Header: "S.No",
                id: "serialNo",
                Cell: ({ row }) => {
                    return row.index + 1;
                },
            },
            {
                Header: "Branch",
                accessor: "branch_id.branch_name",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Type",
                accessor: "type",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Name",
                accessor: "full_name",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Mobile",
                accessor: "contact",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Course",
                accessor: "preferred_training",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        setGlobalFilter,
        setPageSize,
        page,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 10 },
            defaultColumn: { Filter: DefaultColumnFilter },
            filterTypes: {
                multiSelectFilter: (rows, columnIds, filterValue) => {
                    if (!filterValue || filterValue.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => {
                        const rowValue = row.values[columnIds[0]];
                        const rowValueStr = String(rowValue);
                        return filterValue.some((filterVal) =>
                            rowValueStr.includes(String(filterVal))
                        );
                    });
                },
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );





    return (
        <>
            {loading === true ? (
                <div className="loading-overlay">
                    <div className="loading-message">
                        <img
                            className="loadinggif"
                            src={require("../../assets/img/output-onlinegiftools.gif")}
                        />{" "}
                    </div>
                </div>
            ) : (
                <div className="d-none"></div>
            )}
            <div className='top'>
                <div className="" style={{ marginTop: '-80px' }}>
                    <div className="row mb-3">
                        <div className="col-lg-11">
                            <Link to="/dashboard" className="text-secondary dashBoard_text">
                                <b>Dashboard / </b>
                            </Link>

                            <Link to="" className="text-danger dashBoard_text">
                                <b>Skill  Development</b>
                            </Link>
                        </div>
                    </div>
                </div>
                {/* Table */}


                {/* ------------ search and per page ----------------------------*/}
                {/* 
                <div className="mb-3 mt-3">
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
                            <label className='form-label text-dark mt-2'>Show : </label>
                            <div>
                                <select className="form-control w-100 mx-2" onChange={(e) => { setItemsPerPage(e.target.value) }}>
                           
                                    <option value='10'>10</option>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-4 col-sm-1"></div>
                        <div className="col-lg-3 col-md-4 col-sm-7">

                            <div className="w-full flex-1">
                                <form>
                                    <div className="relative">

                                        <input
                                            className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="mb-1 mt-3">
                    <div className="row">
                        <div className="col-lg-7 col-md-4 col-sm-1">
                            <div className='d-flex'>
                                <h5 className='mt-1'>Skill  Development </h5>
                                <div className='mx-3'>
                                    {previllages.add && (
                                        <button className='btn add' onClick={() => setShowModal(true)}>Add</button>


                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

                            {/* </div>

                        <div className="col-lg-3 col-md-4 col-sm-7"> */}
                            <div className="w-full flex-1 me-5">
                                <form>
                                    <div className="relative">
                                        <input
                                            className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={state.globalFilter || ""} // Use the globalFilter value
                                            onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className='d-flex me-2'>
                                <label className="form-label text-dark mt-1">Show : </label>
                                <div>
                                    <select
                                        className="form-control w-100 mx-2"
                                        value={state.pageSize}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === 'All') {
                                                setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                                            } else {
                                                setPageSize(Number(value));
                                            }
                                        }}
                                    >
                                        <option value="All">All</option> {/* Add 'All' option */}
                                        {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                                            <option key={pageSize} value={pageSize}>
                                                {pageSize}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* --------------------------------end------------------------------------------- */}
                {/* <div className='card'>
                    <div className="mt-1">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Branch</th>
                                    <th>Type</th>
                                    <th>Name</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.branch_id?.branch_name}</td>
                                        <td>{item.type}</td>
                                        <td>{item.full_name}</td>
                                        <td className='text-center'>
                                            {previllages.edit && (
                                                <button className='btn updelete mx-2' onClick={() => handleUpdate(item._id, item)}><i class="fa-solid fa-pen-to-square"></i></button>)}
                                            {previllages.delete && (<button className='btn delete'
                                                onClick={() => handleOpenModal(item._id, item.full_name)}
                                            > <i class="fa-solid fa-trash-can"></i></button>)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> */}



                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <Th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        <div className="d-flex">
                                            <div className="mx-2">{column.render("Header")}</div>
                                            <div>
                                                {column.canFilter ? column.render("Filter") : null}
                                            </div>
                                            <div className="mx-1">
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? " 🔽"
                                                        : " 🔼"
                                                    : ""}
                                            </div>
                                        </div>
                                    </Th>
                                ))}
                                <Th className="text-center">Action</Th>
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => (
                                        <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                                    ))}
                                    <Td className="text-center">
                                        <ActionsDropdown
                                            row={row.original}
                                            permissions={{
                                                edit: previllages.edit,
                                                delete: previllages.delete,
                                            }}
                                            onEdit={(id, row) =>
                                                handleUpdate(id, row)
                                            }
                                            onDelete={(id, row) =>
                                                handleOpenModal(id, row.full_name)
                                            }
                                            onInfo={(id, row) =>
                                                handlepreview(id, row)
                                            }
                                        />
                                    </Td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>



                {/* Modal for adding a new user */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Add Skill Development </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="form-group">

                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={addData.branch_id._id} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setAddData({ ...addData, branch_id: e.target.value })}
                                        // onBlur={validateFields}
                                        >
                                            <option value="">Select Brand</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>



                                        <label className={addData.branch_id ? "filled" : ""}>
                                            Select Branch
                                        </label>
                                        {errors.branch_id && (
                                            <div className="error-text">{errors.branch_id}</div>
                                        )}

                                    </div>



                                    {/* <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={addData.type} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setAddData({ ...addData, type: e.target.value })}
                                        // onBlur={validateFields}
                                        >
                                            <option value="">Select Brand</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Timing">Corporate Timing</option>
                                        </select>

                                        <label className={addData.type ? "filled" : ""}>
                                            Select Type
                                        </label>
                                        {errors.type && (
                                            <div className="error-text">{errors.type}</div>
                                        )}

                                    </div> */}




                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={addData.type}
                                            onChange={(e) =>
                                                setAddData({ ...addData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={addData.type ? "filled" : ""}>Select Type</label>

                                        {errors.type && <div className="error-text">{errors.type}</div>}

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {addData.type === "Others" && (
                                            <div className="floating-label">
                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    placeholder="Please specify"
                                                    value={addData.other_details || ""}
                                                    onChange={(e) =>
                                                        setAddData({ ...addData, other_details: e.target.value })
                                                    }
                                                />
                                                <label className={addData.other_details ? "filled" : ""}>
                                                    Other Details
                                                </label>
                                                {/* {errors.other_details && <div className="error-text">{errors.other_details}</div>} */}
                                            </div>
                                        )}
                                    </div>



                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            placeholder=""
                                            type="text"
                                            value={addData.full_name}
                                            onChange={(e) => setAddData({ ...addData, full_name: e.target.value })}
                                            // onBlur={validateFields} 
                                            required
                                        />



                                        <label className={addData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                        {errors.full_name && (
                                            <div className="error-text">{errors.full_name}</div>
                                        )}
                                    </div>

                                    {/* <div className="floating-label">
                                    <input className="form-control" placeholder='' type="text" onBlur={validateFields} value={addData.gender} onChange={(e) => setAddData({ ...addData, gender: e.target.value })} required />
                                 
                                    <label className={addData.gender ? "filled" : ""}>
                                        Gender
                                    </label>
                                    {errors.gender && (
                                        <div className="error-text">{errors.gender}</div>
                                    )}
                                </div> */}
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={addData.gender} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setAddData({ ...addData, gender: e.target.value })}
                                        // onBlur={validateFields}
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="Trans-gender">Trans-Gender</option>

                                        </select>

                                        <label className={addData.gender ? "filled" : ""}>
                                            Select Gender
                                        </label>
                                        {errors.gender && (
                                            <div className="error-text">{errors.gender}</div>
                                        )}

                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.contact} onChange={(e) => setAddData({
                                            ...addData, contact: e.target.value

                                        })}
                                            // onBlur={validateFields}
                                            required />
                                        <label className={addData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                        {errors.contact && (
                                            <div className="error-text">{errors.contact}</div>
                                        )}
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="email"
                                            // onBlur={validateFields} 
                                            value={addData.email_address} onChange={(e) => setAddData({ ...addData, email_address: e.target.value })} required />

                                        <label className={addData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                        {errors.email_address && (
                                            <div className="error-text">{errors.email_address}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            //  onBlur={validateFields}
                                            value={addData.course_department} onChange={(e) => setAddData({ ...addData, course_department: e.target.value })} required />

                                        <label className={addData.course_department ? "filled" : ""}>
                                            Course Department
                                        </label>
                                        {errors.course_department && (
                                            <div className="error-text">{errors.course_department}</div>
                                        )}
                                    </div>
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select"
                                            // onBlur={validateFields} 
                                            value={addData.year_of_study} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setAddData({ ...addData, year_of_study: e.target.value })}
                                        >
                                            <option value="">Select Year</option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>

                                        <label className={addData.year_of_study ? "filled" : ""}>
                                            Year Of Study
                                        </label>
                                        {errors.year_of_study && (
                                            <div className="error-text">{errors.year_of_study}</div>
                                        )}
                                    </div>


                                </div>
                                <div className='col-lg-6'>







                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            // onBlur={validateFields} 
                                            value={addData.Institution_name} onChange={(e) => setAddData({ ...addData, Institution_name: e.target.value })} required />

                                        <label className={addData.Institution_name ? "filled" : ""}>
                                            Institution Name
                                        </label>
                                        {errors.Institution_name && (
                                            <div className="error-text">{errors.Institution_name}</div>
                                        )}
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            // onBlur={validateFields}
                                            value={addData.preferred_training} onChange={(e) => setAddData({ ...addData, preferred_training: e.target.value })} required />

                                        <label className={addData.preferred_training ? "filled" : ""}>
                                            Preferred Training
                                        </label>
                                        {errors.preferred_training && (
                                            <div className="error-text">{errors.preferred_training}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            //  onBlur={validateFields}
                                            value={addData.domain} onChange={(e) => setAddData({ ...addData, domain: e.target.value })} required />

                                        <label className={addData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                        {errors.domain && (
                                            <div className="error-text">{errors.domain}</div>
                                        )}
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="date"
                                            //  onBlur={validateFields}
                                            value={addData.from_date} onChange={(e) => setAddData({ ...addData, from_date: e.target.value })} required />

                                        <label className={addData.from_date ? "filled" : ""}>
                                            From Date
                                        </label>
                                        {errors.from_date && (
                                            <div className="error-text">{errors.from_date}</div>
                                        )}
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="date"
                                            //  onBlur={validateFields}
                                            value={addData.to_date} onChange={(e) => setAddData({ ...addData, to_date: e.target.value })} required />

                                        <label className={addData.to_date ? "filled" : ""}>
                                            To Date
                                        </label>
                                        {errors.to_date && (
                                            <div className="error-text">{errors.to_date}</div>
                                        )}
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            //  onBlur={validateFields} 
                                            value={addData.no_of_days} onChange={(e) => setAddData({ ...addData, no_of_days: e.target.value })} required />

                                        <label className={addData.no_of_days ? "filled" : ""}>
                                            No Of Days
                                        </label>
                                        {errors.no_of_days && (
                                            <div className="error-text">{errors.no_of_days}</div>
                                        )}
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            // onBlur={validateFields}
                                            value={addData.fees} onChange={(e) => setAddData({ ...addData, fees: e.target.value })} required />

                                        <label className={addData.fees ? "filled" : ""}>
                                            Fees
                                        </label>
                                        {errors.fees && (
                                            <div className="error-text">{errors.fees}</div>
                                        )}
                                    </div>
                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text"
                                            //  onBlur={validateFields} 
                                            value={addData.year_of_passout} onChange={(e) => setAddData({ ...addData, year_of_passout: e.target.value })} required />

                                        <label className={addData.year_of_passout ? "filled" : ""}>
                                            Year of Passout
                                        </label>
                                        {errors.year_of_passout && (
                                            <div className="error-text">{errors.year_of_passout}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="floating-label col-lg-12">
                                    <input className="form-control" placeholder='' type="text"
                                        //  onBlur={validateFields}
                                        value={addData.remarks} onChange={(e) => setAddData({ ...addData, remarks: e.target.value })} required />

                                    <label className={addData.remarks ? "filled" : ""}>
                                        Remarks
                                    </label>
                                    {errors.remarks && (
                                        <div className="error-text">{errors.remarks}</div>
                                    )}
                                </div>
                            </div>




                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handleSubmit} >Submit</Button>
                    </Modal.Footer>
                </Modal>
                {/* onBlur={validateFields} */}

                <Modal show={isUpdateshowModal} onHide={() => setUpdateShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Update Skill Development </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {/* Other input fields */}


                        <div className="form-group">





                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="floating-label">
                                        <select className="form-select" value={updateData.branch_id._id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                                            <option value="">Select Brand Id</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateData.branch_id.branch_name ? "filled" : ""}>

                                        </label>

                                    </div>


                                    {/* 
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={updateData.type} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, type: e.target.value })}
                                        >
                                            <option value="">Select Brand</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Timing">Corporate Timing</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>
                                            Select Type
                                        </label>

                                    </div> */}


                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.type}
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>Select Type</label>

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {updateData.type === "Others" && (
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Please specify"
                                                value={updateData.other_details || ""}
                                                onChange={(e) =>
                                                    setUpdateData({ ...updateData, other_details: e.target.value })
                                                }
                                            />
                                        )}
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.full_name} onChange={(e) => setUpdateData({ ...updateData, full_name: e.target.value })} required />
                                        <label className={updateData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                    </div>

                                    {/* <div className="floating-label">
                                    <input className="form-control" type="text" placeholder='' value={updateData.gender} onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })} required />
                                    <label className={updateData.gender ? "filled" : ""}>
                                        Gender
                                    </label>
                                </div> */}

                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={updateData.gender} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })} required
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="Trans-gender">Trans-Gender</option>

                                        </select>

                                        <label className={updateData.gender ? "filled" : ""}>
                                            Select Gender
                                        </label>
                                        {/* {errors.gender && (
                                            <div className="error-text">{errors.gender}</div>
                                        )} */}

                                    </div>



                                    {/* 
                        <div className="floating-label">
                            <div className="checkbox-group">
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="Male"
                                        checked={updateData.gender === "Male"}
                                        onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })}
                                        required
                                    />
                                    Male
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="Female"
                                        checked={updateData.gender === "Female"}
                                        onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })}
                                        required
                                    />
                                    Female
                                </label>
                            </div>
                            <label className={updateData.gender ? "filled" : ""}>
                                Gender
                            </label>
                        </div> */}



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.contact} onChange={(e) => setUpdateData({ ...updateData, contact: e.target.value })} required />
                                        <label className={updateData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.email_address} onChange={(e) => setUpdateData({ ...updateData, email_address: e.target.value })} required />
                                        <label className={updateData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.course_department} onChange={(e) => setUpdateData({ ...updateData, course_department: e.target.value })} required />
                                        <label className={updateData.course_department ? "filled" : ""}>
                                            Course Department
                                        </label>
                                    </div>
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={updateData.year_of_study} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, year_of_study: e.target.value })}
                                        >
                                            <option value="" disabled>Select Year</option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>
                                        <label className={updateData.year_of_study ? "filled" : ""}>

                                        </label>
                                    </div>




                                </div>
                                <div className='col-lg-6'>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.Institution_name} onChange={(e) => setUpdateData({ ...updateData, Institution_name: e.target.value })} required />
                                        <label className={updateData.Institution_name ? "filled" : ""}>
                                            Institution Name
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.preferred_training} onChange={(e) => setUpdateData({ ...updateData, preferred_training: e.target.value })} required />
                                        <label className={updateData.preferred_training ? "filled" : ""}>
                                            Preferred Training
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.domain} onChange={(e) => setUpdateData({ ...updateData, domain: e.target.value })} required />
                                        <label className={updateData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" type="date" placeholder='' value={formatDatefitching(updateData.from_date)} onChange={(e) => setUpdateData({ ...updateData, from_date: e.target.value })} required />
                                        <label className={updateData.from_date ? "filled" : ""}>
                                            From Date
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" type="date" placeholder='' value={formatDatefitching(updateData.to_date)} onChange={(e) => setUpdateData({ ...updateData, to_date: e.target.value })} required />
                                        <label className={updateData.to_date ? "filled" : ""}>
                                            To Date
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.no_of_days} onChange={(e) => setUpdateData({ ...updateData, no_of_days: e.target.value })} required />
                                        <label className={updateData.no_of_days ? "filled" : ""}>
                                            No Of Days
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.fees} onChange={(e) => setUpdateData({ ...updateData, fees: e.target.value })} required />
                                        <label className={updateData.fees ? "filled" : ""}>
                                            Fees
                                        </label>
                                    </div>
                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.year_of_passout} onChange={(e) => setUpdateData({ ...updateData, year_of_passout: e.target.value })} required />
                                        <label className={updateData.year_of_passout ? "filled" : ""}>
                                            Year of Passout
                                        </label>
                                    </div>
                                </div>
                                <div className="floating-label col-lg-12">
                                    <input className="form-control" type="text" placeholder='' value={updateData.remarks} onChange={(e) => setUpdateData({ ...updateData, remarks: e.target.value })} required />
                                    <label className={updateData.remarks ? "filled" : ""}>
                                        Remarks
                                    </label>
                                </div>
                            </div>


                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setUpdateShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handleupdatesubmit}>Update</Button>
                    </Modal.Footer>
                </Modal>




                <Modal show={isPreviewshowModal} onHide={() => setisPreviewShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Preview Skill Development  </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {/* Other input fields */}


                        <div className="form-group">





                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="floating-label">
                                        <select className="form-select" disabled value={updateData.branch_id._id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                                            <option value="">Select Brand </option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateData.branch_id.branch_name ? "filled" : ""}>

                                        </label>

                                    </div>


                                    {/* 
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={updateData.type} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, type: e.target.value })}
                                        >
                                            <option value="">Select Brand</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Timing">Corporate Timing</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>
                                            Select Type
                                        </label>

                                    </div> */}


                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.type}
                                            disabled
                                            onChange={(e) =>
                                                setUpdateData({ ...updateData, type: e.target.value })
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Intership">Intership</option>
                                            <option value="Workshop">Workshop</option>
                                            <option value="Seminar">Seminar</option>
                                            <option value="Corporate Training">Corporate Training</option>
                                            <option value="College Project">College Project</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={updateData.type ? "filled" : ""}>Select Type</label>

                                        {/* Show the other_details field only if "Others" is selected */}
                                        {updateData.type === "Others" && (
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control mt-2"
                                                placeholder="Please specify"
                                                value={updateData.other_details || ""}
                                                onChange={(e) =>
                                                    setUpdateData({ ...updateData, other_details: e.target.value })
                                                }
                                            />
                                        )}
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" disabled placeholder='' value={updateData.full_name} onChange={(e) => setUpdateData({ ...updateData, full_name: e.target.value })} required />
                                        <label className={updateData.full_name ? "filled" : ""}>
                                            Full Name
                                        </label>
                                    </div>

                                    {/* <div className="floating-label">
                                    <input className="form-control" type="text" placeholder='' value={updateData.gender} onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })} required />
                                    <label className={updateData.gender ? "filled" : ""}>
                                        Gender
                                    </label>
                                </div> */}

                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" disabled value={updateData.gender} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })} required
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="Trans-gender">Trans-Gender</option>

                                        </select>

                                        <label className={updateData.gender ? "filled" : ""}>
                                            Select Gender
                                        </label>
                                        {/* {errors.gender && (
                                            <div className="error-text">{errors.gender}</div>
                                        )} */}

                                    </div>



                                    {/* 
                        <div className="floating-label">
                            <div className="checkbox-group">
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="Male"
                                        checked={updateData.gender === "Male"}
                                        onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })}
                                        required
                                    />
                                    Male
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="Female"
                                        checked={updateData.gender === "Female"}
                                        onChange={(e) => setUpdateData({ ...updateData, gender: e.target.value })}
                                        required
                                    />
                                    Female
                                </label>
                            </div>
                            <label className={updateData.gender ? "filled" : ""}>
                                Gender
                            </label>
                        </div> */}



                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.contact} onChange={(e) => setUpdateData({ ...updateData, contact: e.target.value })} required />
                                        <label className={updateData.contact ? "filled" : ""}>
                                            Contact
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.email_address} onChange={(e) => setUpdateData({ ...updateData, email_address: e.target.value })} required />
                                        <label className={updateData.email_address ? "filled" : ""}>
                                            Email Address
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.course_department} onChange={(e) => setUpdateData({ ...updateData, course_department: e.target.value })} required />
                                        <label className={updateData.course_department ? "filled" : ""}>
                                            Course Department
                                        </label>
                                    </div>
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" disabled value={updateData.year_of_study} placeholder=''
                                            // onChange={handleBranch}
                                            onChange={(e) => setUpdateData({ ...updateData, year_of_study: e.target.value })}
                                        >
                                            <option value="" disabled>Select Year</option>
                                            <option value="1st Year">1st Year</option>
                                            <option value="2nd Year">2nd Year</option>
                                            <option value="3rd Year">3rd Year</option>
                                            <option value="4th Year">4th Year</option>
                                        </select>
                                        <label className={updateData.year_of_study ? "filled" : ""}>

                                        </label>
                                    </div>

                                </div>
                                <div className='col-lg-6'>





                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.Institution_name} onChange={(e) => setUpdateData({ ...updateData, Institution_name: e.target.value })} required />
                                        <label className={updateData.Institution_name ? "filled" : ""}>
                                            Institution Name
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.preferred_training} onChange={(e) => setUpdateData({ ...updateData, preferred_training: e.target.value })} required />
                                        <label className={updateData.preferred_training ? "filled" : ""}>
                                            Preferred Training
                                        </label>
                                    </div>
                                    <div className="floating-label">

                                        <input className="form-control" type="text" placeholder='' disabled value={updateData.domain} onChange={(e) => setUpdateData({ ...updateData, domain: e.target.value })} required />
                                        <label className={updateData.domain ? "filled" : ""}>
                                            Domain
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" disabled type="date" placeholder='' value={formatDatefitching(updateData.from_date)} onChange={(e) => setUpdateData({ ...updateData, from_date: e.target.value })} required />
                                        <label className={updateData.from_date ? "filled" : ""}>
                                            From Date
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" disabled type="date" placeholder='' value={formatDatefitching(updateData.to_date)} onChange={(e) => setUpdateData({ ...updateData, to_date: e.target.value })} required />
                                        <label className={updateData.to_date ? "filled" : ""}>
                                            To Date
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.no_of_days} onChange={(e) => setUpdateData({ ...updateData, no_of_days: e.target.value })} required />
                                        <label className={updateData.no_of_days ? "filled" : ""}>
                                            No Of Days
                                        </label>
                                    </div>



                                    <div className="floating-label">

                                        <input className="form-control" type="text" placeholder='' disabled value={updateData.fees} onChange={(e) => setUpdateData({ ...updateData, fees: e.target.value })} required />
                                        <label className={updateData.fees ? "filled" : ""}>
                                            Fees
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" disabled type="text" placeholder='' value={updateData.year_of_passout} onChange={(e) => setUpdateData({ ...updateData, year_of_passout: e.target.value })} required />
                                        <label className={updateData.year_of_passout ? "filled" : ""}>
                                            Year_of_Passout
                                        </label>
                                    </div>
                                </div>
                                <div className="floating-label col-lg-12">

                                    <input className="form-control" type="text" placeholder='' disabled value={updateData.remarks} onChange={(e) => setUpdateData({ ...updateData, remarks: e.target.value })} required />
                                    <label className={updateData.remarks ? "filled" : ""}>
                                        Remarks
                                    </label>
                                </div>
                            </div>


                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setisPreviewShowModal(false)}>Cancel</Button>

                    </Modal.Footer>
                </Modal>



                {/* ----------------delete */}

                <Modal className="modal" show={deleteShowModals} onHide={handleCloseModal}>
                    <Modal.Header>
                        <p id="modeti">Are you sure you want to Delete?</p>
                    </Modal.Header>
                    <Modal.Body>


                        <label className="form-label d-flex">
                            <h5 className='mx-1'> Name :</h5> <h5>{getdeletename} </h5>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                        <Button className='submitbut' variant="primary" onClick={handleDelete} >Delete</Button>
                    </Modal.Footer>
                </Modal>
                {/* _------------------------------pagination button -------------------------------- */}


                <div className="mt-3 pb-5">
                    <div className="row">

                        <div className="col-lg-10 col-sm-12">
                            <nav className="d-flex float-right">
                                <ul className="pagination justify-content-center">
                                    <li
                                        className={` page-item ${currentPage === 1 ? "disabled" : ""
                                            }`}
                                    >
                                        <button className="page-link" onClick={goToPrevPage}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li
                                            key={i}
                                            className={`mx-2 page-item ${currentPage === i + 1 ? "active" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link "
                                                onClick={() => paginate(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                            }`}
                                    >
                                        <button className="page-link " onClick={goToNextPage}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>{" "}
                        </div>
                        <div className="col-lg-2 col-sm-12 mt-1">
                            <div className="float-end">
                                <span className="text-dark ">
                                    Page {currentPage} of {totalPages}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>


                {/* ---------------------------------------end ---------------------------------- */}


            </div>
        </>
    )
}

export default Student_internship
